// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Signature__Pad[data-v-85e3ad28] {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #cccccc;\n}\n.Signature__Pad > div[data-v-85e3ad28] {\n    width: 800px;\n    height: 400px;\n    box-shadow: 0px 0px 30px #9e9e9e;\n    border: 1px solid darkgrey;\n}\n", ""]);
// Exports
module.exports = exports;
